"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("babel-polyfill");
var axios_1 = __importDefault(require("axios"));
var auth_1 = require("common/auth");
var query_string_1 = __importDefault(require("query-string"));
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var auth_2 = require("../../ui-shared-lite/auth");
var InjectedModuleView_1 = __importDefault(require("./InjectedModuleView"));
var token = (0, auth_2.getToken)();
if (token) {
    if (window.USE_JWT_COOKIES) {
        axios_1.default.defaults.headers.common[auth_1.CSRF_TOKEN_HEADER] = token;
    }
    else {
        axios_1.default.defaults.headers.common['Authorization'] = "Bearer ".concat(token);
    }
    axios_1.default.defaults.headers.common['X-BP-Workspace'] = window.WORKSPACE_ID;
}
var _a = query_string_1.default.parse(location.search), m = _a.m, v = _a.v;
var alternateModuleNames = {
    'platform-webchat': 'channel-web'
};
var moduleName = alternateModuleNames[m] || m;
var LiteView = /** @class */ (function (_super) {
    __extends(LiteView, _super);
    function LiteView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LiteView.prototype.render = function () {
        var onNotFound = function () { return (react_1.default.createElement("h1", null,
            "Module $",
            moduleName,
            " with view $",
            v,
            " not found")); };
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(InjectedModuleView_1.default, { moduleName: moduleName, lite: true, componentName: v, onNotFound: onNotFound })));
    };
    return LiteView;
}(react_1.default.Component));
react_dom_1.default.render(react_1.default.createElement(LiteView, null), document.getElementById('app'));
